const React = require('react');
const Section = require('../../Section');

class InfoBox extends React.Component {
    render() {
        const {title, description, image, imageLeft, link, externalLink} = this.props;
        const containerClass = [].concat('infobox__container', imageLeft ? 'infobox__container--left' : null).join(' ');
        return (
        <Section className="infobox">
            <div className={containerClass}>
                <div className="infobox__content-container">
                    <h2 className="infobox__title">{title}</h2>
                    <p className="infobox__description">{description}</p>
                    {link && <a href={link} className="infobox__link">Les mer</a>}
                    {!link && externalLink && <a href={externalLink} className="infobox__link">Les mer</a>}
                </div>
                <div className="infobox__image-container" style={{backgroundImage: `url(${image})`}}>
                    <img src={image} />
                </div>
            </div>
        </Section>
        )
    }
}

module.exports = InfoBox;



// WEBPACK FOOTER //
// ./src/main/resources/site/parts/infobox/Component/index.jsx